<template>
  <div>
    <div class="items-center relative" >
      <transition-group
        class="flex relative justify-center items-center overflow-hidden w-full"
        tag="div"
      >
        <div v-for="(row,index) in slides" class="flex justify-center" :key="row.id">
          <img
            :src="url+row.foto+'?token='+token"
            v-if="(index+1) === value"
            class="block w-full h-auto" style="max-width: 500px; max-height: 300px;"
          />
        </div>
      </transition-group>
      <div class="flex items-center justify-center"  v-if="slides.length>0">
        <div class="grid grid-cols-2 pt-2 gap-4  w-full" style="max-width: 500px">
          <button
              class="
            my-auto
            mx-auto
            w-full
            bg-gray-300
            flex-1
            focus:outline-none
            shadow-md
            mx-auto
          "
              @click="previous()"
          >
            <p class="font-bold">&#60;</p>
          </button>

          <button
              class="
            my-auto
            mx-auto
            w-full
            flex-1
            bg-gray-300
            focus:outline-none
            shadow-md
          "
              @click="next()"
          >
            <p class="font-bold">&#62;</p>
          </button>
        </div>
      </div>
      <div class="text-center flex items-center justify-center">
        <p v-for="(row,index) in slides" v-if="(index+1) === value" class="text-center" style="max-width: 500px">
          {{row.descripcion}}
        </p>
      </div>
      <div v-if="slides.length<=0">
        <p class="text-base text-center">No posee imágenes</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "carrousel",
  props: {
    value: {
      type: Number,
      default: () => 1,
    },
    slides: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    url:process.env.VUE_APP_API_URL,
    token:window.localStorage.getItem('token')
  }),
  methods: {
    next() {
      if (this.value === this.slides.length) this.$emit("input", 1);
      else this.$emit("input", this.value + 1);
    },
    previous() {
      if (this.value === 1) this.$emit("input", this.slides.length);
      else this.$emit("input", this.value - 1);
    },
  },
};
</script>

<style scoped>
</style>